import { render } from "./ProductShowPage.vue?vue&type=template&id=6454b83c"
const script = {}

import exportComponent from "C:\\wamp\\www\\GuideParis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__